export const PAGE_TITLE = 'Payment Management';
export const PAGE_SUBTITLE =
  'Monitor and manage all payment transactions across the platform';

export const STAT_LABELS = {
  PENDING: 'Pending',
  PENDING_HELP: 'Awaiting clearance',
  CLEARED: 'Cleared',
  CLEARED_HELP: 'Successfully processed',
  UPCOMING: 'Upcoming',
  UPCOMING_HELP: 'Scheduled for future',
  TOTAL: 'Total Amount',
  TOTAL_HELP: 'All transactions',
} as const;

export const SECTION_TITLES = {
  PENDING: 'Pending Payments',
  CLEARED: 'Cleared Payments',
  UPCOMING: 'Upcoming Payments',
} as const;

export const TABLE_COLUMNS = {
  MERCHANT: 'Merchant',
  AMOUNT: 'Amount',
  DUE_DATE: 'Due Date',
  PAYMENT_DATE: 'Payment Date',
  STATUS: 'Status',
} as const;

export const STATUS_LABELS = {
  PENDING: 'Pending',
  CLEARED: 'Cleared',
  SCHEDULED: 'Scheduled',
} as const;

export const EMPTY_MESSAGES = {
  NO_DATA: 'No data to display',
  NO_DATA_SUB: 'Payment information will appear here once available',
  NO_PENDING: 'No pending payments',
  NO_CLEARED: 'No cleared payments',
  NO_UPCOMING: 'No upcoming payments',
} as const;

export const LOADING_MESSAGE = 'Loading payment data...';

export const PAYMENTS_COUNT_LABEL = (count: number) =>
  `${count} payment${count === 1 ? '' : 's'}`;
